import React from "react";
import { WhoWinsSecondHalf } from "@data-types/sport-stats/SportStatsTypes";
import Graph from "../Graph";
import { useTranslation } from "react-i18next";
import RecentGames from "../RecentGames";

export default function WhoWinsSecondHalfStatistics(props: {
	homeTeam: WhoWinsSecondHalf["data"];
	awayTeam: WhoWinsSecondHalf["data"];
}) {
	const { t } = useTranslation();

	return (
		<>
			<RecentGames
				homeTeamEventCount={props.homeTeam?.eventCount}
				awayTeamEventCount={props.awayTeam?.eventCount}
			/>
			<Graph
				title={t(
					"EVENT.STATISTICS.BETTING_TYPE_STATS.GAMES_WON_SECOND"
				)}
				home={t("OFFER.COMPETITORS.HOME")}
				away={t("OFFER.COMPETITORS.AWAY")}
				data={{
					homeValue: props.homeTeam?.gamesWonSecondHalf,
					awayValue: props.awayTeam?.gamesWonSecondHalf,
				}}
				isPercentage
			/>
		</>
	);
}
